import { Link } from 'react-router-dom';
// Images
import FooterLogo from '../../Assets/Images/logo-web.png';
// Components
import Tweet from '../../Components/Tweet/Tweet';
import Map from '../../Parts/Map/Map';
import SocialMedia from '../../Components/Social-Media/Social-Media';
import ScrollUp from '../../Components/Scroll-Up/Scroll-Up';
// Css
import './Footer.css';

// Fake Server
const data = [
  {
    id: 1,
    url: 'https://m.facebook.com/',
    tooltip: 'facebook',
    icon: 'icon-facebook'
  },

  {
    id: 2,
    url: 'https://twitter.com/',
    tooltip: 'twitter',
    icon: 'icon-twitter',

  },

  {
    id: 3,
    url: 'https://youtube.com/',
    tooltip: 'youtube',
    icon: 'icon-youtube'
  },

  {
    id: 4,
    url: 'https://instagram.com/',
    tooltip: 'instagram',
    icon: 'icon-instagram'
  },
];

function Footer() {
  return (
    <footer className='footer'>
      <div className='container container-lg parent-items'>
        {/* item 01 */}
        <div className='footer-item'
      
        >
          <Link to='/' className='footer-logo'>
            {/* <img src={FooterLogo} alt='footer logo' title='footer logo'/>
             */}
             <Logo />
          </Link>

          <p>We are specialists in the construction of unique and exclusive properties. Our work inspires. We pride ourselves on delivering outstanding quality and design for leading industry projects.</p>

          <Link to='/about' className='btn btn-primary'>learn more</Link>
        </div>

        {/* item 02
        <section className='footer-item'>
          <h3 className='title-sm'>latest tweets</h3>
          
          <a href='https://twitter.com/Theme_Fusion' className='text-link'>Tweets by Theme_Fusion</a>

          <Tweet/>
        </section> */}

        {/* item 03 */}
        <section className='footer-item'>
          <h3 className='title-sm'>contact us today</h3>

          <ul className='list'>
            <li className='list-item'>
              <i className='list-icon icon-globe'></i>
              <p>corporate location  <br/> <span>Manik Apartment, 47/1/7 Jessore Road (south), Prosadpur, Barasat Kolkata, Near Sarama Cinema Hall, Kalyan Krit Sangha Park, West Bengal 700124</span>  </p>
                                    
            </li>

            <li className='list-item'>
              <i className='list-icon icon-home'></i>
              <p>residential location<br/>
              <span>
                House no 11. Asola housing complex, Fatehpur Beri, New Delhi: 110074
              </span>
              </p>
            </li>

            <li className='list-item'>
              <i className='list-icon icon-phone'></i>
              <p>
                <a href='tel:+919354530770' className='text-link'>+919354530770</a> / <a href='tel:+919836669384' className='text-link'>+919836669384</a>
              </p>
            </li>

            <li className='list-item'>
              <i className='list-icon icon-phone'></i>
              <a href='mailto:atzsss1@gmail.com' className='text-link'>atzsss1@gmail.com</a>
            </li>

            <li className='list-item'>
              <i className='list-icon icon-clock'></i>
              <p>monday - friday: 9:00 AM - 6:00 PM</p>
            </li>

            <li className='list-item'>
              <i className='list-icon icon-clock'></i>
              <p>saturday - sunday: 9:00 AM - 12:00 PM</p>
            </li>
          </ul>
        </section>

        {/* item 04 */}
        <section className='footer-item'>
          <h3 className='title-sm'>our location</h3>

          <Map/>
        </section>
      </div>

      {/* footer nav */}
      <nav className='footer-nav'>
        <div className='container container-lg'>
          <p>&copy;copyright 2024 by ATZ SSS Corp Limited | all rights reserved</p>

          {/* <div className='social-media'>
            {data.map(item => {
              const {id,url,tooltip,icon} = item;

              return (
                <div key={id}>
                  <SocialMedia url={url} className='social-media-icon' tooltip={tooltip} icon={icon}/>
                </div>
              );
            })}
          </div> */}
        </div>
      </nav>

      {/* scroll up page */}
      <ScrollUp/>
    </footer>
  );
}

export default Footer;

const Logo = ()=>{
  return(
    <>
     <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    viewBox="0 0 80 80"

  >
    <path
      d="m50.88 19.04.453.342.347.298V20H52c.265.304.509.608.75.93l.216.287c2.598 3.484 3.703 7.606 3.084 11.933-.556 2.777-1.672 4.942-3.41 7.17l-.263.376-.217.264h-.32v.32h-.32v.32c-.876.8-.876.8-1.28.8v.32h-.32v.32l-.96.32v.32c-4.302 1.944-8.736 2.988-13.336 1.302-1.492-.583-2.835-1.276-4.104-2.262l-.66-.45-.46-.35v-.32h-.32v-.32h-.32v-.32h-.32v-.32h-.32a19 19 0 0 1-.76-1.09l-.217-.332c-.965-1.49-1.748-2.937-2.223-4.658l-.086-.297c-.299-1.147-.295-2.293-.294-3.473v-.323c.005-1.659.125-3.142.7-4.707l.187-.523c.842-2.169 2.217-4.336 3.973-5.877h.32v-.32h.32v-.32a15 15 0 0 1 1-.68l.309-.195c5.912-3.672 13.145-3.193 18.531 1.195m-19.776 3.094c-.258.249-.258.249-.224.586h-.32c-1.976 2.346-2.813 5.771-2.696 8.788.242 2.181.904 4.223 2.056 6.092h.32l.11.34c.264.579.576.954 1.01 1.42h.32v.32H32V40c2.944 2.524 6.244 3.51 10.08 3.36a10 10 0 0 0 1.6-.32l.509-.141c2.422-.71 4.45-1.846 6.211-3.699v-.32h.32a18 18 0 0 0 .7-1.05l.188-.295c1.976-3.134 2.494-6.22 1.832-9.855-.334-1.336-.899-2.5-1.6-3.68l-.228-.394c-.267-.456-.267-.456-.572-.886h-.32l-.125-.283c-.211-.386-.443-.648-.755-.957l-.295-.298c-.248-.257-.248-.257-.585-.222v-.32c-1.55-1.3-3.515-2.038-5.44-2.56l-.293-.085c-4.63-.996-8.908.949-12.124 4.139"
      fill="#ffff"
    />
    <path
      d="m40.64 18.72.64.16.09.52c.201.807.613 1.451 1.042 2.157.408.693.752 1.411 1.097 2.138.325.645.713 1.249 1.094 1.861.638 1.03 1.217 2.091 1.796 3.154l.64 1.169.158.29a117 117 0 0 0 1.164 2.061 37 37 0 0 1 1.208 2.26c.246.505.487.992.783 1.469.208.361.208.361.188.771-.151.42-.317.703-.62 1.03h-.32l-.12.3c-.235.4-.426.473-.84.66a198 198 0 0 1-1.92-3.39l-.28-.507c-.2-.423-.2-.423-.2-.903l-.502.011-.658.009-.331.008c-.594.006-1.056.004-1.549-.348-.17-.35-.17-.35-.32-.8a150 150 0 0 0-.48-1.12l-.005.382-.049 3.553-.025 1.827-.025 1.762-.009.673-.014.94-.008.542c-.025.401-.025.401-.185.561-.405.012-.805.015-1.21.01l-.345-.002-.845-.008c-.155-.465-.179-.756-.178-1.24v-.466l.003-.502.001-.515.005-1.629.002-1.103.008-2.707-.372.016-.497.021-.518.023q-.534.022-1.068.035c-.91.039-.91.039-1.666.486a6.4 6.4 0 0 0-.518 1.019l-.301.576-.269.554a31 31 0 0 1-1.19 2.23l-.64-.16v-.32h-.32c-.241-.252-.241-.252-.5-.59l-.261-.332c-.249-.449-.279-.65-.199-1.158a15 15 0 0 1 .63-1.17l.397-.686.207-.353q.484-.832.955-1.671l.184-.326a35 35 0 0 0 .966-1.844c.494-1.013 1.065-1.98 1.641-2.948.424-.718.79-1.427 1.099-2.202h.32l.048-.264c.141-.473.367-.843.622-1.266 1.43-2.248 1.43-2.248 2.37-4.71m-1.12 7.84a15 15 0 0 0-.43.63l-.262.395a29 29 0 0 0-.511.82c-.504.819-.754 1.054-1.677 1.355l-.64 1.28h3.68v-4.48zm2.72.32v4.16h2.88l-.64-1.12h-.32l-.114-.327c-.256-.589-.585-1.106-.936-1.643l-.2-.313a29 29 0 0 0-.511-.755zm5.76 21.76h10.4a62 62 0 0 1-1.89 2.99 48 48 0 0 0-1.988 3.183c-.139.241-.29.475-.443.707h-.32l-.09.38c-.259.653-.606 1.146-1.023 1.708-.463.668-.869 1.375-1.288 2.072h5.92l.32 1.6c.397.625.397.625.8 1.12v.32h-12.8c.298-.596.638-1.131 1.01-1.68q1.02-1.519 2.02-3.05l.269-.41c.438-.671.843-1.334 1.181-2.06h.32l.06-.285c.099-.352.223-.604.413-.914l.189-.311.197-.32.194-.318.362-.591q.335-.549.664-1.101l-4.16.16c.02-1.15.02-1.15.029-1.508.006-.689-.083-1.027-.349-1.692m-19.04-.32h.32l.45.96.253.54a19 19 0 0 1 .492 1.216c.234.635.517 1.232.824 1.834l.167.331c.47.927.957 1.845 1.446 2.763a84 84 0 0 1 1.117 2.177c.856 1.74.856 1.74 1.87 3.39.263.391.263.391.263.711l.48.16v.32c-.62.047-1.239.075-1.86.1l-.531.041c-.527.016-.944.009-1.449-.141-.458-.478-.706-.994-.96-1.6l-.32-.64-4.96-.16-.32.8-.64 1.6h-4c.265-.53.547-1.031.85-1.54.502-.857.955-1.727 1.39-2.62l.44-.87c.419-.838.821-1.683 1.22-2.53a152 152 0 0 1 3.46-6.84m0 7.04L28 57.28h2.08l-.96-1.92zm5.76-6.72H46.4l-.32 1.12q-.065.553-.1 1.11l-.06.97-3.52-.16v10.56h.32v.48h-3.68l.16-.48q.027-.511.033-1.024l.005-.312q.008-.51.013-1.021l.01-.708.024-1.863.026-1.902q.026-1.865.049-3.73l-3.84.16-.04-.9c-.069-.868-.216-1.314-.76-1.98zm4-29.12c-.117.654-.43 1.215-.73 1.8l-.16.315-.39.765h-.32l-.06.283c-.101.36-.232.624-.42.947a70 70 0 0 0-1.17 2.16 87 87 0 0 1-1.673 3.021c-1.175 2.052-2.28 4.145-3.397 6.229h-.32c-.596-1.625-.884-3.228-.8-4.96l.014-.418c.18-3.04 1.68-5.584 3.885-7.611 1.434-1.215 3.604-2.531 5.541-2.531m4.48.16c2.25.296 4.118 1.32 5.76 2.88.205.359.205.359.32.64h.32v.32h.32v.32h.32c1.709 2.917 2.697 5.972 1.858 9.359-.316 1.157-.316 1.157-.578 1.681-.48-.16-.48-.16-.704-.542l-.246-.528a58 58 0 0 0-1.54-2.97 430 430 0 0 1-2.472-4.571 85 85 0 0 0-1.656-2.94 58 58 0 0 1-1.052-1.899l-.193-.355c-.457-.858-.457-.858-.457-1.395"
      fill="#ffff"
    />
    <path
      d="m36.48 35.2.71.07.399.039c.331.051.331.051.491.211q.02.673.016 1.346l-.001.408-.005 1.296-.002.877q-.003 1.077-.008 2.153c-.926-.156-1.73-.318-2.55-.8l-.434-.25a26 26 0 0 1-.856-.55c.083-.892.425-1.54.85-2.31l.19-.352c.389-.719.792-1.43 1.2-2.138m7.664.137c.995.046.995.046 1.376.416.2.317.362.636.52.977l.357.703.167.34c.19.374.411.719.646 1.067.31.52.31.52.31 1.16a181 181 0 0 1-1.2.62l-.338.177-.337.172-.305.157c-.541.219-1.092.34-1.66.474q-.006-1.294-.009-2.589l-.003-.882-.004-1.264-.002-.4q.001-.472.018-.945c.16-.16.16-.16.464-.183M32.8 17.6l.32.16v.48h-.64l.48.32-.32.32a14 14 0 0 0-.16.96l.32.16-.16.48.32.16-.252.211c-.681.582-1.277 1.163-1.828 1.869l-.32-.64h.32l-.08-.3c-.114-.484-.08-.964-.08-1.46l-.48-.16-.32-.32c.22-.24.22-.24.48-.48h.32v-.32h.32v-.32c.374-.282.374-.282.86-.59l.484-.312zm-1.76 3.04v.48l.32-.32zm30.88 8.32c.02.46.02.46 0 .96-.508.508-1.116.414-1.81.45l-.415.031c-.776.043-1.318.056-1.935-.481-.07-.41-.07-.41 0-.8.508-.508 1.116-.408 1.81-.44l.415-.027c.724-.037 1.277-.046 1.935.307m-38.4-.16.32.32c-.091.891-.091.891-.32 1.12-.556.04-1.113.03-1.67.03l-.475.006-.454.001-.418.002c-.343-.039-.343-.039-.663-.359.06-.58.06-.58.16-1.12 1.089-.363 2.403-.203 3.52 0m-2.997 2.327.419.01.455.006.473.016.479.009q.586.011 1.171.031l.32.8c-.275.385-.498.612-.97.706-.402.026-.797.03-1.2.024l-.418.012c-.382-.001-.72-.011-1.092-.102-.334-.406-.334-.406-.48-.8.374-.619.374-.619.843-.713m38.372.051.499-.001.526.002.526-.002.499.001.462.001c.353.022.353.022.513.182.03.39.03.39 0 .8-.536.536-1.26.423-1.99.46l-.469.035-.45.024-.413.024c-.358-.063-.358-.063-.649-.363-.189-.34-.189-.34-.149-.69.236-.571.509-.47 1.095-.471M43.2 19.68c1.224.161 2.449.4 3.36 1.28-.422.467-.678.655-1.28.8-.213.48-.213.48 0 .96-.07.43-.07.43-.16.8-.567-.651-.942-1.332-1.32-2.1l-.176-.347c-.424-.852-.424-.852-.424-1.393M21.92 54.24c.3.18.3.18.48.48.08.55.08.55 0 1.12-.35.4-.35.4-.8.64-.453-.011-.702-.103-1.09-.33-.309-.504-.296-1.017-.19-1.59.47-.596.909-.526 1.6-.32m38.88-.16c.456.357.616.568.8 1.12-.16.5-.16.5-.48.96-.586.181-.934.232-1.51.01-.335-.442-.332-.766-.301-1.31.051-.3.051-.3.231-.62.451-.241.757-.232 1.26-.16M40.64 18.72l.64.16.14.59c.128.517.286 1.001.5 1.49l-.35-.09c-.471-.073-.793-.028-1.25.09l.16.48-.37.11c-.518.253-.657.503-.91 1.01l-.32-.16.188-.34c.946-1.605.946-1.605 1.572-3.34"
      fill="#ffff"
    />
    <path
      d="M51.68 32.48c.32.48.32.48.28 1.02a6.2 6.2 0 0 1-.44 1.38c-.48-.16-.48-.16-.77-.6-.19-.52-.19-.52-.09-.97.22-.35.22-.35.7-.51l.32.16z"
      fill="#1D2326"
    />
    <path
      d="M43.2 19.68c.718.105 1.387.272 2.08.48l-.32.16c-.181.323-.181.323-.32.64v-.32c-.5.262-.5.262-.59.66l-.05.3-.4-.69-.225-.388c-.175-.362-.175-.362-.175-.842"
      fill="#414448"
    />
    <path
      d="m58.436 31.182.465.003.502.002.528.004.53.002 1.3.008v.16h-2.88c-.16.32-.239.613-.32.96l.64.16v.16c-.45.04-.45.04-.96 0-.31-.28-.31-.28-.48-.64.061-.532.113-.789.676-.818"
      fill="#ffff"
    />
    <path
      d="M43.68 35.52h.16v5.6h1.12c-.44.236-.783.356-1.28.48z"
      fill="#676B6D"
    />
    <path
      d="M20.8 28.64c-.16.48-.16.48-.48.64l.16.48-.16.32h3.2v.16q-.83.013-1.66.02l-.477.008-.456.003-.421.005c-.346-.036-.346-.036-.666-.356.06-.58.06-.58.16-1.12.48-.16.48-.16.8-.16m24.16-8.32h.8l.32.8-.96-.32-.16.32-.16-.48zm-.32.32c.193.58.087.743-.16 1.28l-.32-.16c-.1-.49-.1-.49-.16-.96.32-.16.32-.16.64-.16m-22.08 40.8.32.16-.16.64 2.56.16.16-.32v.48h-3.68c.259-.518.396-.753.8-1.12m9.28-30.24.48.16-.96 1.92-.64-.48h.32l.04-.44c.135-.584.309-.781.76-1.16m16.96 6.08.48.16c.11.37.11.37.16.8-.23.29-.23.29-.48.48-.48-.16-.48-.16-.75-.65L48 37.6h.64z"
      fill="#ffff"
    />
    <path
      d="M20.16 31.2h3.36l.32.8-.32.32-.32-.32.16-.48-3.2-.16z"
      fill="#525658"
    />
    <path
      d="m31.71 21.01.45.11-.45.53-.253.298a14 14 0 0 1-.737.772l-.16-.64h.32l-.11-.29c-.05-.35-.05-.35.12-.64.31-.19.31-.19.82-.14m-3.23 28.27.32.48c-.12.39-.12.39-.32.8l-.13.34c-.256.404-.573.56-.99.78.247-.877.665-1.618 1.12-2.4M45.6 21.44l.32.16a54 54 0 0 1-.06.69l-.034.388c-.066.362-.066.362-.386.842h-.32l.02-.54c.046-.587.046-.587-.34-.9h.32l.16-.48zm12.8 27.2-.64 1.12-.64-.16-.16-.8c.492-.146.928-.174 1.44-.16M40 20.32l.32.16-.16.8.32.16-.37.11c-.518.253-.657.503-.91 1.01l-.32-.16.204-.374.266-.486.264-.484A25 25 0 0 0 40 20.32M25.6 54.88c.25.28.25.28.48.64-.02.35-.02.35-.16.64l-.48.16a14 14 0 0 0-.64.64l.22-.68.124-.382c.129-.356.28-.683.456-1.018M48 48.64h2.88v.16l-2.24.16v2.08h-.16l-.024-.322-.036-.428-.034-.422c-.062-.503-.062-.503-.386-1.228m-8-3.52c.64 0 .64 0 1.2.09.485.06.751.072 1.2-.09l.16.48H39.2l.64-.32zm11.84-15.84h.32V32l-.16-.32-.32-.16.16-1.28-.48-.32.64-.16zm-9.76 11.68v.96l-2.24-.16a5.3 5.3 0 0 1 1.28-.48c.809-.32.809-.32.96-.32"
      fill="#ffff"
    />
    <path
      d="m48 36 .48.16c.184.551.16 1.024.16 1.6L48 37.6l-.09-.71-.051-.4-.019-.33z"
      fill="#090E11"
    />
    <path
      d="M44.96 48.64h1.44l-.32 1.12-.16-.48-.8-.16zm0 .48.16.32-.32-.16zm8.96-18.72.32.16c.1.33.1.33.16.64h-.32v.32l.32.16-.48 1.12h-.16a13 13 0 0 1 .16-2.4M42.4 26.56c.507.253.757.392 1.01.91l.11.37-.48.32c-.64-.88-.64-.88-.64-1.6m.96-6.72.8.32v1.44c-.525-.263-.599-.751-.8-1.28zm11.36 33.6h.48l-.8 1.6c-.32-.48-.32-.48-.48-.96h.48z"
      fill="#ffff"
    />
    <path
      d="M27.68 30.88H28q.019.43.03.86l.017.484-.047.416-.48.32c0-.483.024-.923.08-1.4l.045-.388z"
      fill="#2C2F32"
    />
    <path
      d="m49.44 23.2.16.32h.32v.32h.32l.16.64-.35-.25c-.517-.264-.709-.24-1.25-.07l.16-.8zm-8.8-4.48.64.16v.96l-.8-.16zm9.92 36.16.32.64h-.32v.8l-.8.16c.081-.347.16-.64.32-.96h.32zm1.76-18.72.32.48-.48.64.16.32-.96.32zm5.76-4.64.16.32h.32v.48l.64.16v.16c-.46.02-.46.02-.96 0l-.32-.32c.06-.42.06-.42.16-.8M32.64 29.6l.48.16c-.2.554-.428.984-.8 1.44-.11-.44-.11-.44-.16-.96.23-.38.23-.38.48-.64m-.48 31.68.16.32.8-.16c.03.38.03.38 0 .8l-.48.32c-.48-.74-.48-.74-.48-1.28M22.24 28.8c.969-.031.969-.031 1.28 0l.32.32c-.06.5-.06.5-.16.96-.342-.342-.388-.501-.48-.96l-.96-.16z"
      fill="#ffff"
    />
    <path
      d="m37.44 26.08.32.16c-.2.601-.41.678-.96.96h-.32v-.32h.32l.05-.31.11-.33z"
      fill="#0B1214"
    />
    <path
      d="m44.48 22.08.8.32-.16 1.12c-.64-.72-.64-.72-.64-1.44"
      fill="#373A3D"
    />
    <path
      d="M36.96 22.4c.16.48.16.48.036.772L36.48 24h-.16c.078-.969.078-.969.16-1.28zM32 54.88h.32c.25.45.25.45.48.96l-.16.48-.32-.16.16-.32-.48-.16z"
      fill="#ffff"
    />
    <path d="m50.56 41.12.48.64-.64.64c-.1-.37-.1-.37-.16-.8z" fill="#2A2E31" />
    <path d="m27.36 36.64.48.48-.32.8-.48-.48z" fill="#2B2D31" />
    <path
      d="m37.76 24.32.16.48.32.16c-.28.62-.28.62-.64.8l-.16-.48-.16-.32h.32zm-8.96-3.2h.16c.05.35.05.35 0 .8-.38.45-.38.45-.8.8h-.32c.264-.573.597-1.085.96-1.6m15.52-3.2v.32l.46-.01c.5.01.5.01.82.17v.32l-.68-.14-.382-.079c-.372-.1-.68-.237-1.018-.421.48-.16.48-.16.8-.16m6.4 16 .96.16-.16.8-.48-.16c-.19-.41-.19-.41-.32-.8m-20.96 0 .96.32-.32.8h-.32c-.234-.424-.32-.623-.32-1.12m20.8-15.04 1.12.8-.16.32h-.48c-.48-.676-.48-.676-.48-1.12m-21.6 29.44h.32l.32.96-.48-.16-.48.16zm18.4-20.8.8.32v1.12c-.709-.823-.709-.823-.8-1.44"
      fill="#ffff"
    />
    <path
      d="m28.96 21.76.32.16L28 23.04l-.16-.32h.32l.13-.3c.19-.34.19-.34.67-.66m2.4 32 .48.16c.11.33.11.33.16.64h-.64c-.09-.31-.09-.31-.16-.64zm26.56-5.12.48.16-.64.96-.16-.48-.32-.16c.29-.25.29-.25.64-.48m-28.96-8.48.64.16v.32h.32l.16.64h-.32v-.32h-.32v-.32h-.32zm1.12 10.88.48.16c.11.33.11.33.16.64h-.32l-.32.32v-.64l-.32-.16h.32zm20.8-2.4h.96v.16h-.8l.16.96h-.32l-.32-.64h.32zm-2.56-7.84.64.16-.31.13c-.383.172-.383.172-.49.67l-.32-.32zm-4.64-.32.16.64h1.12c-.422.226-.811.38-1.28.48zM42.4 31.2l.8.16-.48.96c-.234-.424-.32-.623-.32-1.12m-12.32-9.12.64.16-.16.8-.16-.32h-.48zM52 20.64c.3.04.3.04.64.16.2.33.2.33.32.64h-.64v-.32H52zm-13.28-1.12c-.092.459-.138.618-.48.96l-.06-.31-.1-.33-.32-.16c.48-.16.48-.16.96-.16m.32-4H40l-.16.48c-.33.11-.33.11-.64.16zm-5.12 42.72c.372.456.6.886.8 1.44l-.64-.32v-.64l-.32-.16zm-4.64-2.56h.32v.48h.48l-.16.64.32.16h-.48zm23.68 0 .64.16-.32.8-.48-.48zm-24.48-6.4.32.48c-.22.32-.22.32-.48.64H28c.3-.94.3-.94.48-1.12m20.32-6.56.48.16v.48h-.32v.32l-.64.16v-.32h.48l-.16-.48z"
      fill="#ffff"
    />
    <path
      d="m47.68 41.28.32.16c.1.33.1.33.16.64h-.48l-.32-.32z"
      fill="#252B2E"
    />
    <path d="M50.4 24.48c.33.37.33.37.64.8l-.16.48h-.32z" fill="#ffff" />
  </svg>
    </>
  )
}